<template>
    <table class="property-summary-details">
        <tbody>
            <tr>
                <td v-if="dpp.propertyTypeDisplay">
                    <i v-bind:class="['icon-year-built', dpp.propertyTypeIcon]"></i>
                    <div class="content">
                        <span>Property type</span>
                        <span>{{ dpp.propertyTypeDisplay }}</span>
                    </div>
                </td>

                <td v-if="dpp.geo.neighborhood">
                    <i class="icon-user-group"></i>
                    <div class="content">
                        <span>{{molang('dpp.propertyDetails.neighborhood')}}</span>
                        <button type="button" class="link" v-scroll="'propertyMapPanel'">
                            {{dpp.geo.neighborhood}}
                        </button>
                    </div>
                </td>
                <td v-if="dpp.yearBuilt > 0">
                    <i class="icon-year-built"></i>
                    <div class="content">
                        <span>Year built</span>
                        <span>
                            {{ dpp.yearBuilt }}
                        </span>
                    </div>
                </td>
                <td v-if="dpp.rdcMoveinReady !== undefined">
                    <i class="icon-box"></i>
                    <div class="content">
                        <span>Move-in ready?</span>
                        <span>
                            <span>{{dpp.rdcMoveinReady === false ? 'No - To be built' : 'Yes'}}</span>
                        </span>
                    </div>
                </td>
                <td>
                    <i class="icon-cash"></i>
                    <div class="content">
                        <span>HOA fee</span>
                        <span>
                            {{dpp.hoafee ? $filters.formatPrice(dpp.hoafee) : '$0'}}{{perHOAUnit()}}
                        </span>
                    </div>
                </td>

                <td v-if="dpp.lotSize">
                    <i class="icon-property-lot"></i>
                    <div class="content">
                        <span>Lot size</span>
                        <span>
                            {{$filters.formatFriendlyLotSize(dpp.lotSize, dpp.lotSizeUnit)}}
                        </span>
                    </div>
                </td>

                <td v-if="getEstimatePriceRange">
                    <button type="button" @click="openDisclaimer" aria-label="Learn about the Movoto estimate"><i class="icon-logo-m-new"></i></button>
                    <div class="content">
                        <span>Movoto estimate</span>
                        <button type="button" class="link" v-scroll="'propertyEstimatePanel'">
                            {{getEstimatePriceRange}}
                        </button>
                    </div>
                </td>

                <td v-if="dpp.garage > 0">
                    <i class="icon-parking"></i>
                    <div class="content">
                        <span>Parking</span>
                        <span>
                            {{ dpp.garage}} <span>garage spaces</span>
                        </span>
                    </div>
                </td>

                <td v-if="getEstRentFee && getEstRentFee.value && !hideEstMonthCost">
                    <i class="icon-investment"></i>
                    <div class="content">
                        <span>Rental estimate</span>
                        <button type="button" class="link" v-scroll="'propertyEstimatePanel'">{{$filters.formatPrice(getEstRentFee.value)}}/month</button>
                    </div>
                </td>
            </tr>
        </tbody>
        <tbody v-if="ispProviders && ispProviders.length > 0">
            <tr class="f7">
                <td class="isp-provider-title">
                    <i class="icon-wifi"></i>
                    <div class="content">
                        <span>Internet options</span>
                    </div>
                </td>
                <td class="isp-provider">
                    <template v-for="(provider, index) in ispProviders.slice(0, 3)" :key="getProviderKey(provider, index)">
                        <span>{{ provider.name }}</span>
                        <span>{{ provider.technology }}</span>
                        <a
                            class="link"
                            :href="provider.link"
                            target="_blank"
                            rel="noopener noreferrer"
                            :data-link-name="provider.cta"
                            @click="onIspClick(provider)"
                        >See Details</a>
                    </template>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script src="./property-summarydetails.js"></script>
<style lang="scss">
@use './property-summarydetails.scss' as *;
</style>

